import styled from 'styled-components'
import { Box, Column } from '@shipt/design-system-layouts'
import { Body } from '@shipt/design-system-typography'
import { type TestimonialCardType } from '@/features/cms/components/CMS/types'
import { theme } from '@/features/shared/constants/shiptTheme'

type Props = {
  card: TestimonialCardType
}
export const TestimonialCard = ({ card }: Props) => {
  const { name, date, story } = card.data
  return (
    <Card spacing="xl" justify="space-between" padding={{ base: ['md', 'lg'], md: ['3xl', 'xxl'] }}>
      <Body size={{ base: 'md', md: 'xxl' }} align="center">
        {story}
      </Body>
      <Box>
        <Body size={{ base: 'md', md: 'xxl' }} strong align="center">
          {name}
        </Body>
        {!!date && (
          <Body size={{ base: 'sm', md: 'xl' }} variant="secondary" align="center">
            {date}
          </Body>
        )}
      </Box>
    </Card>
  )
}

const Card = styled(Column)`
  background-color: ${theme.color.background.base.neutral.subtle_100};
  border-radius: 16px;
`
